import { SortTypeEnum } from "@repo/models";
import { Column, GridBaseProps, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";

import { useRepOnboardingAuditApi } from "../../../api/repOnboardingAuditApi";
import { useRepContext } from "../../../contexts/editableItemContext";
import { RepOnboardingAudit } from "../../../models";

interface Props extends GridBaseProps<RepOnboardingAudit> {}

const columns = [
	new Column("QA Analyst", "qaAnalyst"),
	new OriginalTimezoneDateColumn("Audit Date", "auditDate").dateOnly().withSortBy(SortTypeEnum.descending),
	new Column("Pass", "pass").withBooleanFormat("Pass", "Fail"),
] as Column<RepOnboardingAudit>[];

export default function OnboardingAuditGridBasic(props: Props) {
	const { repId } = useRepContext();
	const { useRepOnboardingAuditsQuery } = useRepOnboardingAuditApi();
	const { data, loaded, clearQuery } = useRepOnboardingAuditsQuery(repId);

	return (
		<GridPreLoaded
			{...props}
			title="QA Audits"
			columns={columns}
			values={data?.data ?? []}
			loading={!loaded}
			getData={clearQuery}
		/>
	);
}
